import {
  CustomBodyCell,
  CustomHeaderCell,
  CustomTableRow
} from '@components/Styles/TableStyle';
import {
  CustomTextField,

} from '@components/Styles/CommonStyle';
import React from 'react';
import { CustomStack } from '@components/Styles/CommonStyle';


const CompanyAccountCreateEmail = React.memo(({ param, setParam }) => {

  return (
    <React.Fragment>
        <CustomTableRow>
            <CustomHeaderCell>계산서 이메일</CustomHeaderCell>
            <CustomBodyCell>
                <CustomTextField
                    type="email"
                    value={param.email}
                    onChange={(e) => setParam({ ...param, email: e.target.value })}
                />
            </CustomBodyCell>
            <CustomHeaderCell>계좌 번호</CustomHeaderCell>
            <CustomBodyCell>
                <CustomStack>
                    <CustomTextField
                    placeholder="은행"
                    value={param.bank}
                    onChange={(e) => setParam({ ...param, bank: e.target.value })}
                    />
                    <CustomTextField
                    placeholder="계좌번호"
                    value={param.accountNumber}
                    onChange={(e) => setParam({ ...param, accountNumber: e.target.value })}
                    />
                </CustomStack>
            </CustomBodyCell>
        </CustomTableRow>
    </React.Fragment>
  );
});

export default CompanyAccountCreateEmail;

